<template>
  <b-card no-body>
    <div
      v-if="details.length > 0"
      class="position-absolute position-top-0 mt-n1 position-right-0 mr-n1"
    >
      <b-button
        class="btn-icon"
        :variant="detailToggle? 'danger' : 'primary'"
        pill
        @click="changeView"
      >
        <FeatherIcon :icon="detailToggle? 'EyeOffIcon' : 'EyeIcon'" />
      </b-button>
    </div>
    <template v-if="!detailToggle">
      <b-card-body class="d-flex justify-content-between align-items-center">
        <div class="truncate">
          <h2 class="mb-25 font-weight-bolder">
            {{ toplam | toCurrency }} TL
          </h2>
          <span>{{ statisticTitle }}</span>
        </div>
        <b-avatar
          :variant="`light-${color}`"
          size="45"
        >
          <feather-icon
            size="21"
            :icon="icon"
          />
        </b-avatar>
      </b-card-body>
      <b-card-footer class="d-flex justify-content-between text-body py-1">
        <div>
          <div>Sadakalar</div>
          <div>Zekatlar</div>
        </div>
        <div class="text-right font-weight-bolder">
          <div>{{ sadaka | toCurrency }} TL</div>
          <div>{{ zekat | toCurrency }} TL</div>
        </div>
      </b-card-footer>
    </template>
    <template v-else>
      <b-card-body
        style="min-height: 94px"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-between border-right"
          >
            <div class="truncate">
              <h4 class="mb-25 font-weight-bolder">
                {{ details[0].toplam | toCurrency }} TL
              </h4>
              <span>{{ details[0].title }}</span>
            </div>
            <b-avatar
              :variant="`light-${details[0].color}`"
              size="35"
            >
              <feather-icon
                size="20"
                :icon="details[0].icon"
              />
            </b-avatar>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-between"
          >
            <div class="truncate">
              <h4 class="mb-25 font-weight-bolder">
                {{ details[1].toplam | toCurrency }} TL
              </h4>
              <span>{{ details[1].title }}</span>
            </div>
            <b-avatar
              :variant="`light-${details[1].color}`"
              size="35"
            >
              <feather-icon
                size="20"
                :icon="details[1].icon"
              />
            </b-avatar>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer
        class="text-body py-1"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="border-right"
          >
            <div class="d-flex justify-content-between">
              <div>
                <div>Sadakalar</div>
                <div>Zekatlar</div>
              </div>
              <div class="text-right font-weight-bolder">
                <div>{{ details[0].sadaka | toCurrency }} TL</div>
                <div>{{ details[0].zekat | toCurrency }} TL</div>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex justify-content-between">
              <div>
                <div>Sadakalar</div>
                <div>Zekatlar</div>
              </div>
              <div class="text-right font-weight-bolder">
                <div>{{ details[1].sadaka | toCurrency }} TL</div>
                <div>{{ details[1].zekat | toCurrency }} TL</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-footer>
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardFooter, BAvatar, BButton, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BCard,
    BCardBody,
    BCardFooter,
    BAvatar,
    BRow,
    BCol,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    zekat: {
      type: [Number, String],
      default: '0',
    },
    sadaka: {
      type: [Number, String],
      default: '0',
    },
    toplam: {
      type: [Number, String],
      default: '0',
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    details: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
  },
  data() {
    return {
      detailToggle: false,
    }
  },
  methods: {
    changeView() {
      this.detailToggle = !this.detailToggle
    },
  },
}
</script>
